import { useInvalidate } from '@refinedev/core'
import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { productCatalogPatchProductPublishStatusMutation } from '@repo/sdk'

interface UsePublishProductReturn {
  publishProduct: (productId: string) => void
  isPublishing: boolean
}

export function usePublishProduct(onSuccess?: () => void): UsePublishProductReturn {
  const invalidate = useInvalidate()
  const { message } = App.useApp()
  const { t } = useTranslation()

  const { mutate, isPending } = useMutation({
    ...productCatalogPatchProductPublishStatusMutation(),
    onSuccess: async (_data, variables) => {
      message.success(t('pages.products.messages.publishSuccess'))
      // refine keys product queries as ['data','default','product-list', …]:
      // a raw ['product-list'] key never matched, so the list stayed stale.
      await invalidate({
        resource: 'product-list',
        invalidates: ['list', 'detail'],
        id: variables.path?.productId,
      })
      onSuccess?.()
    },
    onError: () => {
      message.error(t('pages.products.messages.publishFailed'))
    },
  })

  const publishProduct = (productId: string) => {
    mutate({ path: { productId } })
  }

  return { publishProduct, isPublishing: isPending }
}
